export default {
  'startProcessInstance.startMappings': 'Mapeos de inicio',
  'startProcessInstance.responseMappings': 'Mapeos de respuesta',
  'startProcessInstance.mapping': 'Mapeo',
  'startProcessInstance.addMapping': 'Agregar mapeo',

  'startProcessInstance.form.select.InstanceName': 'Solicitud - Nombre',
  'startProcessInstance.form.select.InstanceIdentifier': 'Solicitud - Identificador Interno',
  'startProcessInstance.form.select.InstanceDetailsViewUrl': 'Solicitud - Url Vista Detalles',
};
